// import React, { useState } from 'react'
// import Sidebar from './Sidebar'
// import { useSearchParams } from 'react-router-dom'


// const ManageContent = () => {
//     const cards = [
//         { heading: "Rubric Type", title: "Success card title", description: "Literacy,Numeracy,Swar", color: `#ed5d74` },
//         { heading: "Skills", title: "Monthwise Skills", description: "Literacy,Numeracy,Swar", color: "#0050bf" }
//     ]

//     const [rubricTypeModal, setrubricTypeModal] = useState(false)
//     const [skillsModal, setskillsModal] = useState(false)

//     const handleRubricModalOpen = () => {
//         setrubricTypeModal(true)
//     }





//     return (
//         <div>
//             <div>
//                 <Sidebar >
//                     <div className='bg-theme_sky_blue h-[10vh] w-full flex items-center px-[20px] text-theme_white'>
//                         <div>
//                             <p>Manage Content</p>
//                         </div>
//                     </div>


//                     {/* page content start  */}

//                     {/* <div className='m-[15px] flex gap-3'>
//                         <div className='w-[20%]'>
//                             <label >Search Name:</label>
//                             <input type="search" className='bg-theme_white px-[10px] py-[5px] w-full rounded-3xl outline-theme_yellow_dark border-theme_sky_blue border-[1px]' />
//                         </div>

//                         <div className='w-[20%]'>
//                             <label >Search Class:</label>

//                             <select className=' w-full ' >
//                                 <option value="">Select Class</option>
//                                 <option value="">I</option>
//                                 <option value="">II</option>
//                                 <option value="">III</option>
//                                 <option value="">IV</option>
//                                 <option value="">V</option>
//                                 <option value="">VI</option>
//                             </select>
//                         </div>

//                         <div className='w-[20%]'>
//                             <label >Search Section:</label>

//                             <select className='w-full' >
//                                 <option value="">Select Section</option>
//                                 <option value="">A</option>
//                                 <option value="">B</option>
//                                 <option value="">C</option>
//                                 <option value="">D</option>
//                                 <option value="">E</option>
//                                 <option value="">F</option>
//                             </select>
//                         </div>

//                         <div className='w-[20%]'>
//                             <label >Search Assessment Period:</label>

//                             <select className=' w-full' >
//                                 <option value="">Select Month</option>
//                                 <option value="">January</option>
//                                 <option value="">February</option>
//                                 <option value="">March</option>
//                                 <option value="">April</option>
//                                 <option value="">May</option>
//                                 <option value="">June</option>
//                             </select>
//                         </div>

//                     </div> */}



//                     {/* cards container start  */}
//                     <div className='card_container '>

//                         <div onClick={() => handleRubricModalOpen()} className='card w-[350px] bg-theme_green text-theme_white  py-[30px] rounded-lg shadow-md shadow-theme_border' >
//                             <h2 className='px-[20px] '>
//                                 Rubric Type
//                             </h2>

//                             <hr className='h-[2px] my-[10px]'>
//                             </hr>

//                             <h3 className='px-[20px] '>
//                                 Success Card Title
//                             </h3>

//                             <p className='px-[20px] text-[13px]'>Literacy, Numeracy, Swar</p>

//                         </div>



//                         <div className='card w-[350px] bg-theme_yellow_dark text-theme_white  py-[30px] rounded-lg shadow-md shadow-theme_border' >
//                             <h2 className='px-[20px] '>
//                                 Rubric Type
//                             </h2>

//                             <hr className='h-[2px] my-[10px]'>
//                             </hr>

//                             <h3 className='px-[20px] '>
//                                 Success Card Title
//                             </h3>

//                             <p className='px-[20px] text-[13px]'>Literacy, Numeracy, Swar</p>

//                         </div>




//                     </div>
//                     {/* cards container end */}
//                     {/* page content end */}


//                 </Sidebar>



//             </div>
//         </div>
//     )
// }

// export default ManageContent


import React, { Fragment, useEffect, useState } from 'react';
import Sidebar from './Sidebar';

import { API } from "./constant"



// icons start 
import { RiEditLine } from "react-icons/ri";
import { MdClose, MdDeleteForever } from "react-icons/md";
import axios, { AxiosHeaders } from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { data } from 'react-router-dom';
import { IoMdClose } from 'react-icons/io';
// icons end

const ManageContent = () => {
    const cards = [
        { heading: "Rubric Type", title: "Success card title", description: "Literacy, Numeracy, Swar", color: `#ed5d74` },
        { heading: "Skills", title: "Monthwise Skills", description: "Literacy, Numeracy, Swar", color: "#0050bf" }
    ];


       // ================user data start ===================
    const [userData, setuserData] = useState([])
    // console.log(userData.role)
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data)
                setuserData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // ================user data end ===================


    const [updateTable, setupdateTable] = useState(false)

    const [rubricTypeModal, setRubricTypeModal] = useState(false);
    const [skillsModal, setSkillsModal] = useState(false);

    const handleRubricModalOpen = () => {
        setRubricTypeModal(true);
    };

    const handleSkillsModalOpen = () => {
        setSkillsModal(true);
    };

    const handleModalClose = () => {
        setRubricTypeModal(false);
        setSkillsModal(false);
    };


    // --------------get all class data start ----------
    const [allClassDATA, setallClassDATA] = useState([])
    useEffect(() => {
        axios.get(`${API}/create-class`)
            .then((res) => {
                // console.log(res)
                setallClassDATA(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])


    // get all months data start
    const [allMonthsData, setallMonthsData] = useState([])
    useEffect(() => {
        axios.get(`${API}/months`)
            .then((res) => {
                console.log(res)
                setallMonthsData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [])
    // get all months data end



    //----------- operationon rubric type modal start -----------------
    const [rubricType, setrubricType] = useState("")
    const [rubricDescription, setrubricDescription] = useState("")


    const submitRubricType = (e) => {
        e.preventDefault()
        const data = {
            rubricType: rubricType,
            rubricDescription: rubricDescription,
        }

        axios.post(`${API}/rubric-type`, data)
            .then((res) => {

                // console.log(res)
                clearFields()
                toast.success(res.data.message)
                setupdateTable(!updateTable)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    // fetch rubric type start 
    const [rubricTypeAllData, setrubricTypeAllData] = useState([])

    useEffect(() => {
        axios.get(`${API}/rubric-type`)
            .then((res) => {
                // console.log(res)
                setrubricTypeAllData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // fetch rubric type end


    // edit rubric type start 
    const [editRubricTypeModal, seteditRubricTypeModal] = useState(false)
    const [getParticularrubricType, setgetParticularrubricType] = useState([])
    const [editRubricTypeName, seteditRubricTypeName] = useState("")
    const [editRubricTypeDescription, seteditRubricTypeDescription] = useState("")

    // console.log(getParticularrubricType)

    const handleRubricTypeModal = (item) => {
        seteditRubricTypeModal(true)
        setgetParticularrubricType(item)
        // Initialize the input states with the item's values
        seteditRubricTypeName(item.rubricType || '');
        seteditRubricTypeDescription(item.rubricDescription || '');
    }


    const editRubricType = async (id) => {
        const data = {
            rubricType: editRubricTypeName,
            rubricDescription: editRubricTypeDescription
        }
        await axios.put(`${API}/rubric-type/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                seteditRubricTypeModal(false)
                setupdateTable(!updateTable)
                toast.success(res.data.message)
            })
            .catch((error) => {
                console.log(error.response.data.message)
            })
    }
    // edit rubric type end



    // delete rubric type start 
    const [deleteRubricTypeModal, setdeleteRubricTypeModal] = useState(false)
    const [deleteRubricTypeID, setdeleteRubricTypeID] = useState("")

    const handledeleteRubricTypeModal = (id) => {
        setdeleteRubricTypeModal(true)
        setdeleteRubricTypeID(id)
    }

    const handledeleteRubricType = async (id) => {
        await axios.delete(`${API}/rubric-type/${id}`)
            .then((res) => {
                setupdateTable(!updateTable)
                setdeleteRubricTypeModal(false)
                toast.success(res.data.message)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                // console.log(error.response.data.message)
            })
    }
    // delete rubric type end

    //-------------- operationon rubric type modal end -------------------





    // -----------------------operation on skills start -----------------------
    const [class_name, setclass_name] = useState("")
    const [month_name, setmonth_name] = useState("")
    const [skill_name, setskill_name] = useState("")
    const [rubric_type_skills, setrubric_type_skills] = useState("")

    const submitSkills = (e) => {
        e.preventDefault()
        const data = {
            class_name: class_name,
            month_name: month_name,
            skill_name: skill_name,
            rubric_type: rubric_type_skills
        }
        axios.post(`${API}/rubric-skills`, data)
            .then((res) => {
                // console.log(res)
                toast.success(res.data.message)
                setupdateTable(!updateTable)
                clearFields()
            })
            .catch((error) => {
                console.log(error)
            })
    }

    // fetch all rubric skills start 
    const [rubricSkillsAllData, setrubricSkillsAllData] = useState([])
    useEffect(() => {
        axios.get(`${API}/rubric-skills`)
            .then((res) => {
                // console.log(res)
                setrubricSkillsAllData(res.data.data)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [updateTable])
    // fetch all rubric skills end


    // edit rubric skills start 
    const [editRubricSkillsModal, seteditRubricSkillsModal] = useState(false)
    const [getParticularRubricSkills, setgetParticularRubricSkills] = useState([])
    const [editClassRubricSkills, seteditClassRubricSkills] = useState("")
    const [editMonthRubricSkills, seteditMonthRubricSkills] = useState("")
    const [editRubricTypeRubricSkills, seteditRubricTypeRubricSkills] = useState("")
    const [editSkillNameRubricSkills, seteditSkillNameRubricSkills] = useState("")

    const handleRubricSkillsEditModal = (item) => {
        seteditRubricSkillsModal(true)
        setgetParticularRubricSkills(item)
        // initialize the input values with item
        seteditClassRubricSkills(item.class_name)
        seteditMonthRubricSkills(item.month_name)
        seteditRubricTypeRubricSkills(item.rubric_type)
        seteditSkillNameRubricSkills(item.skill_name)
    }

    const editRubricSkill = async (id) => {
        const data = {
            class_name: editClassRubricSkills,
            month_name: editMonthRubricSkills,
            rubric_type: editRubricTypeRubricSkills,
            skill_name: editSkillNameRubricSkills
        }
        await axios.put(`${API}/rubric-skills/${id}`, data)
            .then((res) => {
                setupdateTable(!updateTable)
                seteditRubricSkillsModal(false)
                toast.success(res.data.message)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
    }
    // edit rubric skills end


    // delete rubric skill start 
    const [deleteRubricSkillModal, setdeleteRubricSkillModal] = useState(false)
    const [deleteRubricSkillID, setdeleteRubricSkillID] = useState("")

    const handleDeleteRubricSkillModal = (id) => {
        setdeleteRubricSkillModal(true)
        setdeleteRubricSkillID(id)
    }


    const deleteRubricSkill = async (id) => {
        await axios.delete(`${API}/rubric-skills/${id}`)
            .then((res) => {
                setdeleteRubricSkillModal(false)
                setupdateTable(!updateTable)
                toast.success(res.data.message)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
    }
    // delete rubric skill end

    // -----------------------operation on skills end -----------------------



    // ----------------------operation on filter skills start ----------------
    const [filterSkillsClass, setfilterSkillsClass] = useState("");
    const [filterSkillsMonth, setfilterSkillsMonth] = useState("");
    const [filterSkillsRubric, setfilterSkillsRubric] = useState("");

    // ----------------------operation on filter skills end ----------------


    const clearFields = () => {
        setrubricType("")
        setrubricDescription("")
        setclass_name("")
        setmonth_name("")
        setskill_name("")
        setrubric_type_skills("")

    }

    return (
        <div>
            <Sidebar className='min-h-screen relative'>
                {userData.role === 'Super Admin' || userData.role === 'Admin'  ? (
                    <div>
                        <ToastContainer position="top-right" autoClose={3000} />
                        <div className='bg-theme_sky_blue h-[10vh] w-full flex items-center px-[20px] text-theme_white'>
                            <div>
                                <p>Manage Content</p>
                            </div>
                        </div>

                        {/* cards container start */}
                        <div className='card_container flex gap-4 p-[15px] '>
                            {cards.map((card, index) => (
                                <div
                                    key={index}
                                    onClick={index === 0 ? handleRubricModalOpen : handleSkillsModalOpen}
                                    className='card w-[350px] text-theme_white py-[30px] rounded-lg shadow-md shadow-theme_border cursor-pointer'
                                    style={{ backgroundColor: card.color }}
                                >
                                    <h2 className='px-[20px]'>{card.heading}</h2>
                                    <hr className='h-[2px] my-[10px]' />
                                    <h3 className='px-[20px]'>{card.title}</h3>
                                    <p className='px-[20px] text-[13px]'>{card.description}</p>
                                </div>
                            ))}
                        </div>
                        {/* cards container end */}

                        {/* Modal */}
                        {(rubricTypeModal || skillsModal) && (
                            <div className='fixed inset-0  flex'>
                                {/* Backdrop */}
                                <div
                                    className='absolute inset-0 bg-black bg-opacity-50 '
                                    onClick={handleModalClose}
                                ></div>
                                {/* Modal Panel */}
                                <div
                                    className={`absolute top-[15vh] right-0 w-[40%] bg-theme_yellow_light  overflow-auto transition-transform duration-300 ease-in-out ${rubricTypeModal || skillsModal ? 'translate-x-0' : 'translate-x-full'
                                        }`}
                                    style={{ height: 'calc(100% - 10vh)' }}
                                >
                                    <div className='p-6'>
                                        <div className='flex justify-between items-center mb-4'>
                                            <h2 className='text-xl font-semibold'>
                                                {rubricTypeModal ? 'Rubric Type Modal' : 'Skills Modal'}
                                            </h2>
                                            <button
                                                className='text-gray-600 hover:text-gray-800' onClick={handleModalClose}>
                                                ✕
                                            </button>
                                        </div>
                                        <p className='text-[12px]'>
                                            {rubricTypeModal
                                                ? 'Feed your Rubric type details here -'
                                                : 'Content for Skills Modal'}
                                        </p>


                                        {
                                            rubricTypeModal ? (



                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label className='text-[12px]'>Rupric type:</label>
                                                                </div>
                                                                <input value={rubricType} onChange={(e) => setrubricType(e.target.value)} type="text" className='w-[70%] h-[25px] text-[12px]' />
                                                            </div>
                                                            <div className='w-full my-[10px]'>
                                                                <div>
                                                                    <label className='text-[12px]'>Rupric description:</label>
                                                                </div>
                                                                <input value={rubricDescription} onChange={(e) => setrubricDescription(e.target.value)} type="text" className='w-[70%] h-[25px] text-[12px]' />
                                                            </div>

                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitRubricType} className='bg-theme_yellow_dark_transparent text-white px-[10px] py-[5px] rounded-lg text-[12px]'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[10px] py-[5px] rounded-lg text-[12px]'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>

                                                            <th>Sno.</th>
                                                            <th>Rubric Name</th>
                                                            <th>Description</th>
                                                            <th>Edit</th>
                                                            <th>Delete</th>

                                                            <tbody>
                                                                {/* <tr className='text-center '>
                                                            <td>1</td>
                                                            <td>Literacy</td>
                                                            <td>dsfalkdsflkeflds;fds;lf;</td>
                                                            <td><RiEditLine size={20} /></td>
                                                            <td><MdDeleteForever size={20} /></td>
                                                        </tr> */}

                                                                {
                                                                    rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                                        return (

                                                                            <tr key={index} className='text-center '>
                                                                                <td>{index + 1}</td>
                                                                                <td>{item.rubricType}</td>
                                                                                <td>{item.rubricDescription}</td>
                                                                                <td><RiEditLine size={20} onClick={() => handleRubricTypeModal(item)} /></td>
                                                                                <td><MdDeleteForever size={20} onClick={() => handledeleteRubricTypeModal(item._id)} /></td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>


                                            ) : (

                                                <div>
                                                    <div>
                                                        <form >
                                                            <div className='flex gap-[4px]'>
                                                                <div className='w-[30%] my-[10px]'>
                                                                    <div>
                                                                        <label >Select Class:</label>
                                                                    </div>
                                                                    <select value={class_name} onChange={(e) => setclass_name(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                        <option value="">Select Class</option>
                                                                        {
                                                                            allClassDATA && allClassDATA.map((item, index) => {
                                                                                return (
                                                                                    <Fragment key={index}>
                                                                                        <option value={item.name}>{item.name}</option>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                        }
                                                                        {/* <option value="I">I</option>
                                                            <option value="II">II</option>
                                                            <option value="III">III</option>
                                                            <option value="IV">IV</option>
                                                            <option value="V">V</option>
                                                            <option value="VI">VI</option> */}
                                                                    </select>
                                                                </div>

                                                                <div className='w-[30%] my-[10px]'>
                                                                    <div>
                                                                        <label >Select Month:</label>
                                                                    </div>
                                                                    <select value={month_name} onChange={(e) => setmonth_name(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                        <option value="">Select Month</option>
                                                                        {
                                                                            allMonthsData && allMonthsData.map((item, index) => {
                                                                                return (
                                                                                    <Fragment key={index}>
                                                                                        <option value={item.name}>{item.name}</option>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                        }

                                                                    </select>
                                                                </div>

                                                                <div className='w-[30%] my-[10px]'>
                                                                    <div>
                                                                        <label >Select Rubric Type:</label>
                                                                    </div>
                                                                    <select value={rubric_type_skills} onChange={(e) => setrubric_type_skills(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                        <option value="">Select Rubric Type</option>
                                                                        {
                                                                            rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                                                return (
                                                                                    <Fragment key={index}>
                                                                                        <option value={item.rubricType}>{item.rubricType}</option>
                                                                                    </Fragment>
                                                                                )
                                                                            })
                                                                        }

                                                                    </select>
                                                                </div>

                                                            </div>
                                                            <div className='w-full my-[5px]'>
                                                                <div>
                                                                    <label >Enter Skill Name:</label>
                                                                </div>
                                                                <input value={skill_name} onChange={(e) => setskill_name(e.target.value)} type="text" className='w-[70%] h-[25px]' />
                                                            </div>

                                                            <div className='my-[20px] flex gap-4'>
                                                                <button onClick={submitSkills} className='bg-theme_yellow_dark_transparent text-white px-[10px] py-[5px] rounded-lg text-[12px]'>Submit</button>
                                                                <button onClick={clearFields} className='bg-theme_border text-theme_black px-[10px] py-[5px] rounded-lg text-[12px]'>Clear</button>
                                                            </div>
                                                        </form>
                                                    </div>


                                                    <div>
                                                        <div className='flex gap-[4px]'>
                                                            <div className='w-[30%]'>
                                                                <div>
                                                                    <label >Filter Class:</label>
                                                                </div>
                                                                <select value={filterSkillsClass} onChange={(e) => setfilterSkillsClass(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                    <option value="">Select Class</option>
                                                                    {
                                                                        allClassDATA && allClassDATA.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }
                                                                    {/* <option value="I">I</option>
                                                            <option value="II">II</option>
                                                            <option value="III">III</option>
                                                            <option value="IV">IV</option>
                                                            <option value="V">V</option>
                                                            <option value="VI">VI</option> */}
                                                                </select>
                                                            </div>

                                                            <div className='w-[30%] '>
                                                                <div>
                                                                    <label >Filter Month:</label>
                                                                </div>
                                                                <select value={filterSkillsMonth} onChange={(e) => setfilterSkillsMonth(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                    <option value="">Select Month</option>
                                                                    {
                                                                        allMonthsData && allMonthsData.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.name}>{item.name}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                            </div>

                                                            <div className='w-[30%] '>
                                                                <div>
                                                                    <label >Filter Rubric Type:</label>
                                                                </div>
                                                                <select value={filterSkillsRubric} onChange={(e) => setfilterSkillsRubric(e.target.value)} className=' w-full h-[25px] text-[12px]' >
                                                                    <option value="">Select Rubric Type</option>
                                                                    {
                                                                        rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                                            return (
                                                                                <Fragment key={index}>
                                                                                    <option value={item.rubricType}>{item.rubricType}</option>
                                                                                </Fragment>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='my-[10px]'>
                                                        <table className='border border-separate'>
                                                            <thead className='text-[12px]'>
                                                                <th>Sno.</th>
                                                                <th>Class name</th>
                                                                <th>Month</th>
                                                                <th>Rubric Type</th>
                                                                <th>Skill</th>
                                                                <th>Edit</th>
                                                                <th>Delete</th>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    rubricSkillsAllData && rubricSkillsAllData.filter((item) => {
                                                                        const classMatch = filterSkillsClass === "" || item.class_name === filterSkillsClass;
                                                                        const monthMatch = filterSkillsMonth === "" || item.month_name === filterSkillsMonth;
                                                                        const rubricMatch = filterSkillsRubric === "" || item.rubric_type === filterSkillsRubric;
                                                                        return classMatch && monthMatch && rubricMatch;
                                                                    })
                                                                        .map((item, index) => {
                                                                            return (

                                                                                <tr key={index} className='text-center text-[12px]'>
                                                                                    <td >{index + 1}</td>
                                                                                    <td >{item.class_name}</td>
                                                                                    <td>{item.month_name}</td>
                                                                                    <td>{item.rubric_type}</td>
                                                                                    <td>{item.skill_name}</td>
                                                                                    <td><RiEditLine size={20} onClick={() => handleRubricSkillsEditModal(item)} /></td>
                                                                                    <td><MdDeleteForever size={20} onClick={() => handleDeleteRubricSkillModal(item._id)} /></td>
                                                                                </tr>
                                                                            )
                                                                        })
                                                                }

                                                            </tbody>
                                                        </table>

                                                    </div>

                                                </div>

                                            )
                                        }



                                    </div>
                                </div>
                            </div>
                        )}

                        {/* ==============rubric type edit and delete modal start===============  */}

                        {
                            editRubricTypeModal && (
                                <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                    <div className='w-[350px]'>
                                        <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'>
                                            <h5 className='text-white text-[25px]'>Edit School Location</h5>
                                            <button onClick={() => seteditRubricTypeModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                        {/* input field block start */}
                                        <div className='p-[10px] bg-white'>

                                            <div className='p-[5px] '>
                                                <div className='w-full'>
                                                    <label htmlFor="edit_school_location">Rubric Type:</label>
                                                    <input id='edit_school_location' value={getParticularrubricType?.rubricType}
                                                        onChange={(e) => {
                                                            const newClassname = e.target.value
                                                            setgetParticularrubricType((prev) => ({ ...prev, rubricType: newClassname }))
                                                            seteditRubricTypeName(newClassname)
                                                        }
                                                        }
                                                        className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='School Location' />
                                                </div>

                                                <div className='w-full'>
                                                    <label htmlFor="edit_school_location">Rubric Description:</label>
                                                    <input id='edit_school_location' value={getParticularrubricType?.rubricDescription}
                                                        onChange={(e) => {
                                                            const newClassname = e.target.value
                                                            setgetParticularrubricType((prev) => ({ ...prev, rubricDescription: newClassname }))
                                                            seteditRubricTypeDescription(newClassname)
                                                        }
                                                        }
                                                        className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='School Location' />
                                                </div>

                                            </div>
                                            <div className=' p-[5px] flex justify-start my-[10px]'>
                                                <button onClick={() => editRubricType(getParticularrubricType._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                            </div>

                                        </div>
                                        {/* input field block end */}
                                    </div>
                                </div>
                            )
                        }


                        {
                            deleteRubricTypeModal && (
                                <div className='inset-0 fixed flex justify-center  items-center bg-black/70'>
                                    <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                        <div className='flex justify-between items-center pb-[20px]'>
                                            <div>
                                                <h1 className='text-[20px]'>Delete Rubric Modal</h1>
                                            </div>
                                            <div>
                                                <MdClose onClick={() => setdeleteRubricTypeModal(false)} size={30} />
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='mt-[20px] '>
                                            <p className='w-[95%] text-center'>
                                                Deleting Rubric Type might affect your records. Do you still want to delete?
                                            </p>
                                            <div className='flex justify-around mt-[30px]'>
                                                <button onClick={() => handledeleteRubricType(deleteRubricTypeID)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                <button onClick={() => handledeleteRubricTypeModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }

                        {/* ==============rubric type edit and delete modal start===============  */}



                        {/*================ rubric skills edit and delete modal start===========  */}
                        {
                            editRubricSkillsModal && (
                                <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                    <div className='w-[350px]'>
                                        <div className='bg-theme_blue py-[10px] px-[10px] flex justify-between'>
                                            <h5 className='text-white text-[25px]'>Edit Rubric Skills</h5>
                                            <button onClick={() => seteditRubricSkillsModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                        {/* input field block start */}
                                        <div className='p-[10px] bg-white'>

                                            <div className='p-[5px] '>

                                                <div className='w-full my-[10px]'>
                                                    <div>
                                                        <label >Select Class:</label>
                                                    </div>
                                                    <select value={getParticularRubricSkills.class_name}
                                                        onChange={(e) => {
                                                            const newData = e.target.value
                                                            setgetParticularRubricSkills((prev) => ({ ...prev, class_name: newData }))
                                                            seteditClassRubricSkills(newData)
                                                        }}
                                                        className=' w-[70%] ' >
                                                        <option value="">Select Class</option>
                                                        {
                                                            allClassDATA && allClassDATA.map((item, index) => {
                                                                return (
                                                                    <Fragment key={index}>
                                                                        <option value={item.name}>{item.name}</option>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }
                                                        {/* <option value="I">I</option>
                                                            <option value="II">II</option>
                                                            <option value="III">III</option>
                                                            <option value="IV">IV</option>
                                                            <option value="V">V</option>
                                                            <option value="VI">VI</option> */}
                                                    </select>
                                                </div>

                                                <div className='w-[70%] my-[10px]'>
                                                    <div>
                                                        <label >Select Month:</label>
                                                    </div>
                                                    <select value={getParticularRubricSkills.month_name}

                                                        onChange={(e) => {
                                                            const newData = e.target.value
                                                            setgetParticularRubricSkills((prev) => ({ ...prev, month_name: newData }))
                                                            seteditMonthRubricSkills(newData)
                                                        }}
                                                        className=' w-full' >
                                                        <option value="">Select Month</option>
                                                        {
                                                            allMonthsData && allMonthsData.map((item, index) => {
                                                                return (
                                                                    <Fragment key={index}>
                                                                        <option value={item.name}>{item.name}</option>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }

                                                    </select>
                                                </div>

                                                <div className='w-[70%] my-[10px]'>
                                                    <div>
                                                        <label >Select Rubric Type:</label>
                                                    </div>
                                                    <select value={getParticularRubricSkills.rubric_type}
                                                        onChange={(e) => {
                                                            const newData = e.target.value
                                                            setgetParticularRubricSkills((prev) => ({ ...prev, rubric_type: newData }))
                                                            seteditRubricTypeRubricSkills(newData)
                                                        }}
                                                        className=' w-full' >
                                                        <option value="">Select Rubric Type</option>
                                                        {
                                                            rubricTypeAllData && rubricTypeAllData.map((item, index) => {
                                                                return (
                                                                    <Fragment key={index}>
                                                                        <option value={item.rubricType}>{item.rubricType}</option>
                                                                    </Fragment>
                                                                )
                                                            })
                                                        }

                                                    </select>
                                                </div>

                                                <div className='w-full my-[10px]'>
                                                    <div>
                                                        <label >Enter Skill Name:</label>
                                                    </div>
                                                    <input value={getParticularRubricSkills.skill_name}
                                                        onChange={(e) => {
                                                            const newData = e.target.value
                                                            setgetParticularRubricSkills((prev) => ({ ...prev, skill_name: newData }))
                                                            seteditSkillNameRubricSkills(newData)
                                                        }}
                                                        type="text" className='w-[70%]' />
                                                </div>
                                            </div>
                                            <div className=' p-[5px] flex justify-start my-[10px]'>
                                                <button onClick={() => editRubricSkill(getParticularRubricSkills._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                            </div>

                                        </div>
                                        {/* input field block end */}
                                    </div>
                                </div>
                            )
                        }



                        {
                            deleteRubricSkillModal && (
                                <div className='inset-0 fixed flex justify-center  items-center bg-black/70'>
                                    <div className='bg-theme_sky_blue text-white w-[30%] px-[10px] py-[20px] '>
                                        <div className='flex justify-between items-center pb-[20px]'>
                                            <div>
                                                <h1 className='text-[20px]'>Delete Rubric Skills</h1>
                                            </div>
                                            <div>
                                                <MdClose onClick={() => setdeleteRubricSkillModal(false)} size={30} />
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='mt-[20px] '>
                                            <p className='w-[95%] text-center'>
                                                Deleting Rubric Skills might affect your records. Do you still want to delete?
                                            </p>
                                            <div className='flex justify-around mt-[30px]'>
                                                <button onClick={() => deleteRubricSkill(deleteRubricSkillID)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_red hover:text-white'>Delete</button>
                                                <button onClick={() => setdeleteRubricSkillModal(false)} className='px-[10px] py-[5px] bg-theme_white text-black hover:bg-theme_green hover:text-white'>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                        {/*================ rubric skills edit and delete modal end===========  */}
                    </div>
                ) : null
                }
            </Sidebar>
        </div>
    );
};

export default ManageContent;
